const colors = require('../colors/colorPalette');
const TAG_STATUS_COLORS = require('../colors/tagStatusColors');

module.exports = { colors, TAG_STATUS_COLORS };
